<template>
  <div ref="chartDomRef" class="widget"></div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from 'vue'
import { debounce } from '@safety/shared-utils'
import * as echarts from 'echarts'

defineExpose({
  resize: () => {
    if (chart && !chart.isDisposed()) {
      chart.resize()
    }
  }
})
const props = defineProps({ title: String, inner: Array, outer: Array })
const chartDomRef = ref(null)
let chart = null

const renderChart = debounce(function () {
  //为了提高性能,使用debounce,导致会延迟执行,此时chart实例可能已经被销毁
  if (!chart || chart.isDisposed()) return
  chart.setOption({
    title: {
      text: '订单渠道构成',
      textStyle: {
        color: 'white',
        textShadowColor: 'rgba(255, 255, 255, 0.5)',
        textShadowBlur: 15
      },
      left: 'center',
      top: '5%'
    },
    tooltip: {
      show: false
    },
    series: [
      {
        type: 'pie',
        top: '20%',
        height: '80%',
        radius: ['20%', '40%'],
        label: {
          show: true,
          position: 'inner',
          color: 'white',
          fontSize: 10
        },
        data: props.inner,
        itemStyle: {
          shadowColor: 'rgba(255, 255, 255, 0.5)',
          shadowBlur: 15
        },
        center: ['50%', '55%']
      },
      {
        type: 'pie',
        top: '20%',
        height: '80%',
        radius: ['50%', '70%'],
        label: {
          show: true,
          color: 'white',
          formatter: '{b} {c}'
        },
        data: props.outer,
        itemStyle: {
          shadowColor: 'rgba(255, 255, 255, 0.5)',
          shadowBlur: 15
        },
        center: ['50%', '55%']
      }
    ],
    textStyle: {
      color: 'rgb(99, 158, 216)'
    }
  })
}, 1000)

onMounted(() => {
  chart = echarts.init(chartDomRef.value, 'light')
  renderChart()
})

onUnmounted(() => {
  chart?.dispose()
})

watch([() => props.title, () => props.inner, () => props.outer], renderChart)
</script>

<style lang="scss" scoped>
.widget {
  width: 100%;
  height: 100%;
}
</style>
